module.exports = __webpack_public_path__ + "media/images/mobile/abouts/m_zl-f27979b8ef2ee34c3378cd62d0431130.png";